import { Button } from "@/components/ui/baseUi/button"
import { useChatPageContext } from "@modules/chat/contexts/chatPageContext"
import { UserPlusIcon, UsersIcon, XIcon } from "lucide-react"
import { useEffect } from "react"

type ChannelListHeaderProps = {
  onResetSearch: () => void
}

export const ChannelListHeader: React.FC<ChannelListHeaderProps> = ({ onResetSearch }) => {
  const {
    updateIsCreatingNewChannel,
    updateIsAddingMembersToChannel,
    updateIsCreatingGroup,
    isCreatingNewChannel,
    isAddingMembersToChannel,
  } = useChatPageContext()

  const openOneToOneChannelCreation = () => {
    updateIsCreatingGroup(false)
    updateIsCreatingNewChannel(true)
    onResetSearch()
  }
  const openGroupChannelCreation = () => {
    updateIsCreatingGroup(true)
    updateIsCreatingNewChannel(true)
    onResetSearch()
  }
  const closeChannelCreation = () => {
    updateIsAddingMembersToChannel(undefined)
    updateIsCreatingNewChannel(false)
    onResetSearch()
  }

  useEffect(() => {
    return () => {
      closeChannelCreation()
    }
  }, [])

  const isUserSearchOpen = isCreatingNewChannel || !!isAddingMembersToChannel

  return (
    <div className="mb-2 flex w-full items-center justify-center gap-3 overflow-hidden pt-2 pr-3 pb-1 pl-3">
      {isUserSearchOpen ? (
        <Button size="sm" variant="outline" onClick={closeChannelCreation} className="h-8 w-8">
          <XIcon color="currentColor" />
        </Button>
      ) : (
        <>
          <Button size="sm" variant="outline" onClick={openGroupChannelCreation} className="h-8 w-8">
            <UsersIcon color="currentColor" />
          </Button>
          <Button size="sm" variant="outline" onClick={openOneToOneChannelCreation} className="h-8 w-8">
            <UserPlusIcon color="currentColor" />
          </Button>
        </>
      )}
    </div>
  )
}
